import { getCustomizedDate } from "../constants";
import moment from "moment";
let obj = getCustomizedDate(6, "Days");
let initialState = {
  dateValue: {
    global_dashboard: { data: obj?.date },
    dashboard_section: { data: obj?.date },
    dashboard_widget: { data: obj?.date },
    template_global: { data: obj?.date },
    template_section: { data: obj?.date },
    template_widget: { data: obj?.date },
    graph_page: { data: obj?.date },
    orm_dashboard: { data: obj?.date },
    split: { data: { one: obj?.date, two: obj?.date, three: obj?.date } },
    share_modal: { data: obj?.date },
    widgetMaker: { data: obj?.date },
    advance_settings: { data: obj?.date },
    preview: { data: obj?.date },
    schedule_date_time: { data: obj?.date },
    schedule_duration: { data: obj?.date },
    CommandCenter: { data: obj?.date },
  },

  timeValue: {
    global_dashboard: { data: obj?.time },
    dashboard_section: { data: obj?.time },
    dashboard_widget: { data: obj?.time },
    template_global: { data: obj?.time },
    template_section: { data: obj?.time },
    template_widget: { data: obj?.time },
    graph_page: { data: obj?.time },
    orm_dashboard: { data: obj?.time },
    split: { data: { one: obj?.time, two: obj?.time, three: obj?.time } },
    share_modal: { data: obj?.time },
    widgetMaker: { data: obj?.time },
    advance_settings: { data: obj?.time },
    preview: { data: obj?.time },
    schedule_date_time: { data: obj?.time },
    schedule_duration: { data: obj?.time },
    CommandCenter: { data: obj?.date },
  },
  dateRange: {
    days: 14,
    from: obj?.date[0] + obj?.time.startTime,
    to: obj?.date[1] + obj?.time.endTime,
  },
  relativeCount: null,
  dateTimeFlag: { flag: false, msg: null },
  crisisChecked: { check1: false, check2: false, check3: false },
  crisisDates: null,
  dashboardDateFilterObj: null,
  singleDate: { AgentActivity: moment().format("YYYY/MM/DD") },
  previewDate: null,
};
const DateTime = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DATE_VALUE":
      return {
        ...state,
        dateValue: action.payload,
      };
    case "SET_TIME_VALUE":
      return {
        ...state,
        timeValue: action.payload,
      };
    case "SET_DATE_RANGE":
      return {
        ...state,
        dateRange: action.payload,
      };
    case "SET_PREVIEW_DATE":
      return {
        ...state,
        previewDate: action.payload,
      };
    case "SET_RELATIVE_COUNT":
      return {
        ...state,
        relativeCount: action.payload,
      };
    case "SET_DATETIME_FLAG":
      return {
        ...state,
        dateTimeFlag: action.payload,
      };
    case "SET_CRISIS_CHECKED":
      return {
        ...state,
        crisisChecked: action.payload,
      };
    case "SET_CRISIS_DATE":
      return {
        ...state,
        crisisDates: action.payload,
      };
    case "DASHBOARD_DATE_FFILTER_OBJ":
      return {
        ...state,
        dashboardDateFilterObj: action.payload,
      };
    case "SET_SINGLE_DATE":
      return {
        ...state,
        singleDate: action.payload,
      };
    default:
      return state;
  }
};

export default DateTime;
